import React, { useState } from 'react';
import api from '../services/api';

/* Os três sinais de um abastecimento mal lançado, na própria linha da despesa.

     ⛽  o sistema suspeita — esbatida enquanto é só suspeita, cheia depois de
         alguém confirmar que aquele sítio vende combustível
     ✓ ✕ a decisão: é abastecimento, ou não é (e nesse caso o sítio deixa de
         ser sugerido)
     avisar  o botão de avisar o colaborador, depois de validado — continua
         lá depois do envio, porque insistir é normal; o histórico dos envios
         está no envelope da caixa de escolha, à esquerda do fornecedor

   Sem o passo do meio isto seria um robô a mandar mensagens a montadores por
   sua conta. É por isso que o ✓ existe.
   ============================================================ */
const SinalCombustivel = ({ s, onMudou }) => {
    const [ocupado, setOcupado] = useState(false);
    const [msg, setMsg] = useState(null);
    const [erro, setErro] = useState('');
    if (!s) return null;

    const decidir = async (descartar) => {
        setOcupado(true); setErro('');
        try {
            await api.post(`/combustivel/suspeitas/${s.despesa_id}/validar`, { descartar });
            onMudou && onMudou();
        } catch (e) { setErro(e.response?.data?.error || e.message); }
        finally { setOcupado(false); }
    };

    const abrirMensagem = async (e) => {
        e.stopPropagation();
        setOcupado(true); setErro('');
        try {
            const r = await api.get(`/combustivel/suspeitas/${s.despesa_id}/mensagem`);
            setMsg(r.data);
        } catch (e2) { setErro(e2.response?.data?.error || e2.message); }
        finally { setOcupado(false); }
    };

    /* Abrir a conversa e registar o envio no mesmo clique. Separar as duas
       coisas obrigava a confirmar à mão o que se acabara de fazer — e uma
       janela bloqueada pelo browser ficava registada na mesma. */
    const enviar = async () => {
        setOcupado(true); setErro('');
        const janela = window.open(
            `https://wa.me/${msg.numero}?text=${encodeURIComponent(msg.texto)}`, '_blank');
        if (!janela) {
            setErro('O browser bloqueou a janela do WhatsApp. Autoriza as janelas para este site.');
            setOcupado(false);
            return;
        }
        try {
            await api.post(`/combustivel/suspeitas/${s.despesa_id}/enviada`,
                { texto: msg.texto, para: msg.numero, canal: 'whatsapp' });
            setMsg(null);
            onMudou && onMudou();
        } catch (e) { setErro(e.response?.data?.error || e.message); }
        finally { setOcupado(false); }
    };

    const botao = {
        border: '1px solid #cbd5e1', background: '#fff', borderRadius: 5,
        padding: '0 5px', fontSize: '0.72rem', cursor: 'pointer', lineHeight: '17px',
    };

    return (
        <span style={{ fontSize: '0.72rem', display: 'inline-flex', alignItems: 'center', gap: 5 }}
            onClick={e => e.stopPropagation()}>
            <span title={`${s.detalhe}${s.marca_manual ? '' : '\n\nAinda é só suspeita: confirme com o visto.'}`}
                style={{ opacity: s.marca_manual ? 1 : 0.5 }}>⛽</span>

            {s.validado_em || s.enviado_em ? (
                /* Avisar continua disponível depois de enviado: insistir é normal.
                   O envelope com o histórico está na caixa de escolha, à esquerda
                   do fornecedor — o mesmo sítio que nos movimentos sem fatura. */
                <button style={{ ...botao, color: '#1d4ed8', borderColor: '#93c5fd' }}
                    disabled={ocupado} onClick={abrirMensagem} title="Avisar quem lançou">avisar</button>
            ) : s.descartado_em ? (
                <span style={{ color: '#94a3b8' }}>não é abastecimento</span>
            ) : (
                <>
                    <button style={{ ...botao, color: '#166534', borderColor: '#86efac' }}
                        disabled={ocupado} title="É abastecimento — confirmar"
                        onClick={e => { e.stopPropagation(); decidir(false); }}>✓</button>
                    <button style={{ ...botao, color: '#b91c1c', borderColor: '#fca5a5' }}
                        disabled={ocupado} title="Não é abastecimento — e não voltar a sugerir este sítio"
                        onClick={e => { e.stopPropagation(); decidir(true); }}>✕</button>
                </>
            )}
            {erro && <span style={{ color: '#b91c1c' }}>{erro}</span>}

            {msg && (
                <div onClick={() => setMsg(null)}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 2000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div onClick={e => e.stopPropagation()}
                        style={{ background: '#fff', borderRadius: 12, padding: '20px 22px', width: 520, maxWidth: '92vw' }}>
                        <h3 style={{ margin: '0 0 4px', fontSize: '1.05rem' }}>Avisar {msg.quem || 'o colaborador'}</h3>
                        {msg.aviso && <p style={{ color: '#b45309', fontSize: '0.85rem', margin: '0 0 10px' }}>⚠ {msg.aviso}</p>}
                        {erro && <p style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c',
                            borderRadius: 8, padding: '8px 10px', fontSize: '0.8rem', margin: '0 0 10px' }}>{erro}</p>}
                        <textarea value={msg.texto} rows={9}
                            onChange={e => setMsg({ ...msg, texto: e.target.value })}
                            style={{ width: '100%', boxSizing: 'border-box', padding: 10, border: '1px solid #cbd5e1',
                                borderRadius: 8, fontSize: '0.86rem', resize: 'vertical' }} />
                        <p style={{ fontSize: '0.78rem', color: '#64748b', margin: '8px 0 14px' }}>
                            {msg.numero
                                ? <>Vai para <strong>+{msg.numero}</strong>. O Enviar abre o WhatsApp com o
                                    texto escrito e fica logo registado aqui — falta só carregares em
                                    enviar lá.</>
                                : 'Sem número não é possível abrir o WhatsApp. Pode copiar o texto e enviar por outra via.'}
                        </p>
                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                            <button className="btn-secondary" onClick={() => setMsg(null)}>Cancelar</button>
                            <button className="btn-secondary"
                                onClick={() => navigator.clipboard?.writeText(msg.texto)}>Copiar texto</button>
                            {msg.numero && (
                                <button className="btn-primary" disabled={ocupado} onClick={enviar}>
                                    📲 Enviar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </span>
    );
};

export default SinalCombustivel;
